import React, {Fragment} from "react";
import {useAuth0} from "../react-auth0-spa";
import "../scss/bootstrap.scss"
import "./hz.css"

const Navbar = () => {
    const {isAuthenticated, user, loginWithRedirect, logout} = useAuth0();
    return (

        <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
            <a href="/" className="navbar-brand d-flex align-items-center border-end px-4 px-lg-5">
                <h2 className="m-0 text-primary"><img className="position-relative w-75 h-75" src={"img/logo.png"}/></h2>
            </a>
            {/*<button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse"*/}
            {/*        data-bs-target="#navbarCollapse">*/}
            {/*    <span className="navbar-toggler-icon"></span>*/}
            {/*</button>*/}
            <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-auto p-4 p-lg-0">
                    <a href="/" className="nav-item nav-link active">Home</a>
                    {/*<a href="service" className="nav-item nav-link">Service</a>*/}
                    {/*<a href="project" className="nav-item nav-link">Product</a>*/}
                    {/*<a href="methodology" className="nav-item nav-link">Methodology</a>*/}
                    <a href="about" className="nav-item nav-link">Contact Us</a>
                    {/*<div className="nav-item dropdown">*/}
                    {/*    <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</a>*/}
                    {/*    <div className="dropdown-menu bg-light m-0">*/}
                    {/*        <a href="feature.html" className="dropdown-item">Feature</a>*/}
                    {/*        <a href="quote.html" className="dropdown-item">Free Quote</a>*/}
                    {/*        <a href="team.html" className="dropdown-item">Our Team</a>*/}
                    {/*        <a href="testimonial.html" className="dropdown-item">Testimonial</a>*/}
                    {/*        <a href="404.html" className="dropdown-item">404 Page</a>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<a href="contact" className="nav-item nav-link">Contact</a>*/}
                </div>
                {/*<button className="btn btn-primary btn-lg btn-login btn-block" >Sign in</button>*/}


                {!isAuthenticated && (<a href="" className="btn btn-primary rounded-0 py-4 px-lg-5 d-none d-lg-block"
                                         onClick={() => loginWithRedirect({})}>Sign in<i
                    className="fa fa-arrow-right ms-3"></i></a>)}
                {isAuthenticated &&
                    <span className="btn btn-primary rounded-0 py-4 px-lg-5 d-none d-lg-block" onClick={() => logout()}>Log out</span>}
            </div>
        </nav>
    )
}

export default Navbar;